export default "__VITE_ASSET__Dv7Qt0dX__"